// extracted by mini-css-extract-plugin
export default {"faSpinner":"App_faSpinner__qR2i6"};